import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createBlock(_component_v_menu, {
    modelValue: _ctx.isOpened,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isOpened) = $event)),
    "offset-y": true,
    "close-on-content-click": false
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_btn, _mergeProps(props, {
          "data-testid": "table-layout",
          icon: "",
          style: {"width":"30px","height":"30px"},
          variant: "flat"
        }), {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { color: "primary" }, {
              default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                _createTextVNode(" mdi-table ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 16)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_v_list, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getAvailableHeaders, (header) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: header.value,
              "data-testid": _ctx.t(`item-${header.text}`)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_checkbox, {
                  modelValue: header.checked,
                  "onUpdate:modelValue": ($event: any) => ((header.checked) = $event),
                  label: _ctx.t(`station_table.table.${header.text}`).toString(),
                  "hide-details": "",
                  onChange: _ctx.updateHeaderSelection
                }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "onChange"])
              ]),
              _: 2
            }, 1032, ["data-testid"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}